import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { DesaparecidoService } from 'src/app/core/services/caso/desaparecido.service';
import { DesaparecidoVo } from 'src/app/shared/models/caso/desaparecido-vo.model';

import { FormBuilder, FormGroup } from '@angular/forms';
import { RowInput } from 'jspdf-autotable';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'vex-reporte-list',
  templateUrl: './reporte-list.component.html',
  styleUrls: ['./reporte-list.component.scss']
})
export class ReporteListComponent implements OnInit {

  appSettings = AppSettings;
  stateConstant = StateConstant;

  dataSource: MatTableDataSource<DesaparecidoVo>;
  displayedColumns: string[] = ['id', 'apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'gestion', 'color_ojos', 'color_cabellos', 'sexo', 'nacionalidad', 'fecha_nacimiento', 'fecha_desaparicion', 'peso', 'tez', 'estatura', 'vestimenta', 'resumen', 'lugar_hecho', 'encontrado', 'latitud', 'longitud', 'url_thumbnail', 'url_photo', 'url_pdf_report', 'url_pdf_image_report', 'edad', 'referencia', 'departamento', 'provincia', 'municipio', 'encontrado', 'fecha_registro', 'hora_registro', 'lugar_remision', 'responsable_seguimiento', 'atencion', 'albergue', 'derivacion', 'entrega', 'atencion_fecha', 'atencion_hora', 'atencion_centro'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selection = new SelectionModel<DesaparecidoVo>(true, []);
  searchKey: string;

  desaparecidoService = inject(DesaparecidoService);
  authService = inject(AuthService);

  desaparecidos: any[];

  crumbs: AppRooute[] = [RouteConstant.ROUTE_REPORT_MISSING];
  reportData: RowInput = [];

  formSearch: FormGroup;
  role: any;

  constructor(private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private toatrService: ToastrService) {
    this.formSearch = this.fb.group({
      desde: [''],
      hasta: [''],
      documento: [''],
      complemento: [''],
      nombres: [''],
      paterno: [''],
      materno: [''],
      encontrado: [''],
    });
    if (this.authService.isAuthenticated())
      this.role = this.authService.user.roles[0].nombre_rol;
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.role = this.authService.user.roles[0];
      if (this.role.id_rol == 66)
        this.displayedColumns = ['id', 'apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'gestion', 'color_ojos', 'color_cabellos', 'sexo', 'nacionalidad', 'fecha_nacimiento', 'fecha_desaparicion', 'peso', 'tez', 'estatura', 'vestimenta', 'resumen', 'lugar_hecho', 'encontrado', 'latitud', 'longitud', 'url_thumbnail', 'url_photo', 'url_pdf_report', 'url_pdf_image_report', 'edad', 'referencia', 'departamento', 'provincia', 'municipio', 'encontrado', 'atencion_fecha', 'atencion_hora', 'atencion_centro'];
      if (this.role.id_rol == 67)
        this.displayedColumns = ['id', 'apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'gestion', 'color_ojos', 'color_cabellos', 'sexo', 'nacionalidad', 'fecha_nacimiento', 'fecha_desaparicion', 'peso', 'tez', 'estatura', 'vestimenta', 'resumen', 'lugar_hecho', 'encontrado', 'latitud', 'longitud', 'url_thumbnail', 'url_photo', 'url_pdf_report', 'url_pdf_image_report', 'edad', 'referencia', 'departamento', 'provincia', 'municipio', 'encontrado', 'fecha_registro', 'hora_registro', 'lugar_remision', 'responsable_seguimiento', 'atencion', 'albergue', 'derivacion', 'entrega'];
    }

    this.loadList();
  }

  loadList(): void {
    this.desaparecidoService.findAllReport(this.formSearch.value.desde, this.formSearch.value.hasta, this.formSearch.value.documento, this.formSearch.value.complemento, this.formSearch.value.nombres, this.formSearch.value.paterno, this.formSearch.value.materno, this.formSearch.value.encontrado).subscribe(
      response => {
        this.desaparecidos = response.data
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      err => {
        console.error(err);
      }
    )
  }

  hformatDates(myDate: any) {
    const format = 'dd/MM/yyyy HH:mm';
    //const myDate = '2019-06-29';
    const date = new Date(myDate);
    const locale = 'en-US';
    return formatDate(date, format, locale);
  }

  formatDates(myDate: any) {
    const format = 'dd/MM/yyyy';
    //const myDate = '2019-06-29';
    const date = new Date(myDate);
    const locale = 'en-US';
    return formatDate(date, format, locale);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filter() {
    this.loadList();
  }

  clear() {
    this.formSearch.reset();
    this.loadList();
  }

  exportPdf() {
    window.open(this.desaparecidoService.getPdfReportUrl(this.formSearch.value.desde, this.formSearch.value.hasta, this.formSearch.value.documento, this.formSearch.value.complemento, this.formSearch.value.nombres, this.formSearch.value.paterno, this.formSearch.value.materno, this.formSearch.value.encontrado), '_blank');
  }

}
